import { initialState } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.constants';
import { State } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.reducers';
import { AppState } from 'mk2/reducers';

export const getSellerSearchState = (state: AppState): State =>
    state.containers.bazaar.sellerSearch || initialState;
